import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../store/dux/field-boundary-management-dux';
import { useContext } from './context';
import { useActiveTab } from './use-active-tab';
import { useFields } from '../../hooks/use-fields';

export function useMapClick() {
  const dispatch = useDispatch();
  const { selectedFeatures, setSelectedFeatures, setFocusedFeature } =
    useContext();
  const { isIrrigation, layer: activeLayer } = useActiveTab();
  const { focusAaid } = useFields();

  const toggleFeatureSelection = React.useCallback(
    (featureId) => {
      if (selectedFeatures.includes(featureId)) {
        setSelectedFeatures((current) =>
          current.filter((id) => id !== featureId),
        );
      } else {
        setSelectedFeatures((current) => [...current, featureId]);
      }
      setFocusedFeature(null);
    },
    [selectedFeatures, setFocusedFeature, setSelectedFeatures],
  );

  return useCallback(
    (layer, featureId) => {
      if (isIrrigation) {
        setFocusedFeature(featureId);
        toggleFeatureSelection(featureId);
      } else if (layer === activeLayer) {
        focusAaid(featureId);
        dispatch(actions.toggleFieldSelection(featureId));
      }
    },
    [
      activeLayer,
      dispatch,
      focusAaid,
      isIrrigation,
      setFocusedFeature,
      toggleFeatureSelection,
    ],
  );
}
